import cls from 'clsx';
import React from 'react';
import { A } from '@/components/atoms/A/A';
import { Ul } from '@/components/atoms/List/List';
import { H2, Li, Span } from '@/components/atoms/Typography/Typography';
import styles from './Contact.module.scss';

interface ContactEntryProps {
  label: string;
  url: string;
  urlLabel: string;
  children?: undefined;
  onClick?: () => void;
  color?: 'primary' | 'default' | 'white';
}

interface ContactProps {
  children: React.ReactNode;
  title: string;
  times?: string;
  className?: string;
  color?: 'primary' | 'default' | 'white';
}

export const ContactEntry = ({
  label,
  url,
  urlLabel,
  color = 'white',
  onClick,
}: ContactEntryProps) => (
  <Li className={styles.contactEntry}>
    <Span color={color}>{label}</Span>{' '}
    <A color={color} href={url} onClick={onClick} target="_blank">
      {urlLabel}
    </A>
  </Li>
);

export const Contact = ({
  title,
  times,
  children,
  className,
  color = 'white',
}: ContactProps) => (
  <div className={cls(styles.container, className)}>
    <H2 version="level3" color={color}>
      {title}
    </H2>
    <Ul>
      {times && (
        <Li className={styles.contactEntry}>
          <Span color={color}>{times}</Span>
        </Li>
      )}
      {children}
    </Ul>
  </div>
);
